import { stripIndent } from 'common-tags'

export const churnPredictionQueries = [{
  id: 0,
  title: 'Predict churn',
  description: 'Given the user and behavior data of a single user, this query predicts whether the user is at risk of churn.',
  endpoint: 'api/v1/_predict',
  query: stripIndent`
    {
      "from": "DataTable”,
      "where": {
        "Location": "Helsinki",
        "Gender": "F",
        "Age": 48,
        "Monthly Fee": 30,
        "Months as User": 10,
        "Online Service": "No",
        "Special Deal": "No",
        "Monthly Usage": "Small"
      },
      "predict": "Churned"
    }
    `,
  response: stripIndent`
      {
        "$p": 0.124,
        "feature": "Yes"
      }
    `,
  responseExplanation: 'There’s a 12.4% chance this user will churn next month'
},
{
  id: 1,
  title: 'Predict churn triggers',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu pulvinar arcu.',
  endpoint: 'api/v1/_predict',
  query: stripIndent`
    {
      "from": "DataTable”,
      "where": {
        "Gender": "F",
        "Monthly Fee": 30,
        "Months as User": 10,
      },
      "recommend": "Location",
      "goal": {""}
    }
    `,
  response: stripIndent`
      {
        "$p": 0.124,
        "feature": "Yes"
      }
    `,
  responseExplanation: 'There’s a 12.4% chance this user will churn next month'
},
{
  id: 2,
  title: 'Analyze users',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eu pulvinar arcu.',
  endpoint: 'api/v1/_predict',
  query: stripIndent`
    {
      "from": "DataTable”,
      "where": {
        "Location": "Helsinki",
        "Gender": "F",
        "Age": 48,
        "Monthly Fee": 30,
        "Months as User": 10,
        "Online Service": "No",
        "Special Deal": "No",
        "Monthly Usage": "Small"
      },
      "predict": "Churned"
    }
    `,
  response: stripIndent`
      {
        "$p": 0.124,
        "feature": "Yes"
      }
    `,
  responseExplanation: 'There’s a 12.4% chance this user will churn next month'
}]

export const leadAssignmentQueries = [{
  id: 0,
  title: 'Get content',
  description: 'See what kind of data has been uploaded into Aito. ',
  endpoint: 'api/v1/_query',
  query: stripIndent`
      {
        "from": "AssignedLeads",
        "limit": 3
      }
    `,
  response: stripIndent`
      {
        "business_type": "B2B",
        "case_won": true,
        "company_revenue_last_year": 2000000.0,
        "company_type": "software",
        "companyid": 1985,
        "country": "Argentina",
        "number_of_employees": 35,
        "sales_rep": 9999
      },
      {
        "business_type": "B2B",
        "case_won": true,
        "company_revenue_last_year": 5100000.0,
        "company_type": "software",
        "companyid": 2128,
        "country": "Argentina",
        "number_of_employees": 100,
        "sales_rep": 9999
      },
      {
        "business_type": "B2B, B2C",
        "case_won": true,
        "company_revenue_last_year": 15000.0,
        "company_type": "hardware, software",
        "companyid": 324,
        "country": "Argentina",
        "number_of_employees": 4,
        "sales_rep": 2
      }
    `,
  responseExplanation: 'The rows in the AssignedLeads table have these attributes. The request is limited to return only the first 3 rows.'
},
{
  id: 1,
  title: 'Predict suitable sales rep',
  description: ' Return a sales rep, that has dealt with similar leads in the past.',
  endpoint: 'api/v1/_predict',
  query: stripIndent`
      {
        "from": "AssignedLeads",
        "where": {
          "country": "United States of America",
          "company_type": "software",
          "company_revenue_last_year": {"$numeric": 50000000},
          "number_of_employees": {"$numeric": 200000000},
          "business_type": "B2B"
        },
        "predict": "sales_rep",
        "select": ["field", "feature", "$p", "$why"]
      }
    `,
  response: stripIndent`
      {
        "field": "sales_rep",
        "feature": 121,
        "$p": 0.733755883187221,
        "$why": {
          "type": "product",
          "factors": [
            {
              "type": "baseP",
              "value": 0.030612244897959183
            },
            {
              "type": "normalizer",
              "name": "exclusiveness",
              "value": 0.8452300373509757
            },
            {
              "type": "relatedVariableLift",
              "variable": "country:United States of America",
              "value": 26.070263065753785
            },
            {
              "type": "relatedVariableLift",
              "variable": "business_type:B2B",
              "value": 0.7379672551240622
            },
            {
              "type": "relatedVariableLift",
              "variable": "company_type:software",
              "value": 1.2358728347997527
            },
            {
              "type": "relatedVariableLift",
              "variable": "Company_Revenue_Last_Year in [2800000.0, 9.0E7]",
              "value": 1.0282884786201085
            }
          ]
        }
      }
    `,
  responseExplanation: 'With 73% probability sales rep 121 should be assigned for the case as he usually deals with customers from the United states of America'
},
{
  id: 2,
  title: 'Recommend a sales rep to win the lead',
  description: 'Return a sales rep who would be the most probable to win the deal.',
  endpoint: 'api/v1/_recommend',
  query: stripIndent`
      {
        "from": "AssignedLeads",
        "where": {
          "country": "Estonia",
          "company_type": "software",
          "company_revenue_last_year": {"$numeric": 500},
          "number_of_employees": {"$numeric": 20},
          "business_type": "B2B"
        },
        "recommend": "sales_rep",
        "goal": { "case_won": true },
        "select": ["feature", "$p"]
      }
    `,
  response: stripIndent`
      {
        "feature": 9999,
        "$p": 0.5500582492741447
      }
    `,
  responseExplanation: 'Sales rep 9999 is the most probable sales rep to win this lead (create a new customer) with the probability of 55%.'
},
{
  id: 3,
  title: 'Evaluate prediction accuracy',
  description: 'Evaluate how accurate the sales rep prediction is by taking every fourth row as test data and leaving the rest for training. ',
  endpoint: 'api/v1/_evaluate',
  query: stripIndent`
      {
        "test": {
        "$index": {
        "$mod": [4, 0]
          }
        },
        "evaluate": {
          "from": "AssignedLeads",
          "where": {
            "country": {"$get": "country"},
            "company_type": {"$get": "company_type"},
            "company_revenue_last_year": {"$get": "company_revenue_last_year"},
            "number_of_employees": {"$get": "number_of_employees"},
            "business_type": {"$get": "business_type"}
          },
          "predict": "sales_rep",
          "select": ["field", "feature", "$p", "$why"]
        },
        "select": ["trainSamples", "testSamples", "baseAccuracy", "accuracyGain", "accuracy", "error", "baseError"]
      }
    `,
  response: stripIndent`
      {
        "trainSamples": 1611.0,
        "testSamples": 537,
        "baseAccuracy": 0.3333333333333333,
        "accuracyGain": 0.6033519553072626,
        "accuracy": 0.9366852886405959,
        "error": 0.06331471135940414,
        "baseError": 0.6666666666666667
      }
    `,
  responseExplanation: 'The predictions are 94% accurate'
}]

export const cabinetMatchingQueries = [{
  id: 0,
  title: 'Get content',
  description: 'See what kind of data has been uploaded into Aito. ',
  endpoint: 'api/v1/_query',
  query: stripIndent`
      {
      "from": "doorTable",
      "limit": 3
      }
    `,
  response: stripIndent`
      {
        "color" : "walnut",
        "doorID" : 1,
        "door_name" : "ingaro",
        "height" : 10,
        "width" : 20
      }, {
        "color" : "walnut",
        "doorID" : 2,
        "door_name" : "ingaro",
        "height" : 20,
        "width" : 20
      }, {
        "color" : "walnut",
        "doorID" : 3,
        "door_name" : "ingaro",
        "height" : 30,
        "width" : 20
      }
    `,
  responseExplanation: 'The rows in the doorTable table have these attributes. The request is limited to return only the first 3 rows.'
},
{
  id: 1,
  title: 'Similarity of items',
  description: 'Find a Helsingö kitchen door match for an IKEA cabinet frame.',
  endpoint: 'api/v1/_similarity',
  query: stripIndent`
      {
      "from": "doorTable",
      "similarity": {
        "door_name": "ensio",
        "height": 60,
        "width": 20,
        "color": "walnut"
      },
      "limit": 1
    }
    `,
  response: stripIndent`
      {
        "$score" : 2.6277385236617437,
        "color" : "walnut",
        "doorID" : 76,
        "door_name" : "ensio",
        "height" : 60,
        "width" : 20
      }
    `,
  responseExplanation: 'The query finds the matching cabinet door from the measurements of the kitchen cabinet and specified door type.'
}]

export const missingValuesQueries = [{
  id: 0,
  title: 'Get content',
  description: 'See the data that has already been uploaded into Aito.',
  endpoint: 'api/v1/_query',
  query: stripIndent`
      {
        "from": "invoice_data",
        "limit": 3
      }
    `,
  response: stripIndent`
    {
      "GL_Code": "GL-6100410",
      "Inv_Amt": 83.24,
      "Inv_Id": 15001,
      "Item_Description": "Artworking/Typesetting Production Jun 2009 Champion Parts Inc SMAP Prototype and Comp Production/Packaging Design",
      "Product_Category": "CLASS-1963",
      "Vendor_Code": "VENDOR-1676"
    },
    {
      "GL_Code": "GL-2182000",
      "Inv_Amt": 51.18,
      "Inv_Id": 15002,
      "Item_Description": "Auto Leasing Corporate Services Corning Inc /Ny 2013-Mar  Auto Leasing and Maintenance Other Corporate Services",
      "Product_Category": "CLASS-1250",
      "Vendor_Code": "VENDOR-1883"
    },
    {
      "GL_Code": "GL-6050100",
      "Inv_Amt": 79.02,
      "Inv_Id": 15004,
      "Item_Description": "Store Management Lease/Rent Deltona Corp Real Estate Base Rent Jul2018",
      "Product_Category": "CLASS-1274",
      "Vendor_Code": "VENDOR-1999"
    }
    `,
  responseExplanation: 'The rows in the invoice_data table have these attributes. The request is limited to return only the first 3 rows.'
},
{
  id: 1,
  title: 'Predict missing value',
  description: 'Given the other known values, this query predicts the value of “Prodct_Category” field.',
  endpoint: 'api/v1/_predict',
  query: stripIndent`
      {
        "from": "invoice_data",
        "where": {
            "GL_Code": "GL-6100410",
            "Inv_Amt": {"$numeric": 83.24},
            "Inv_Id": 15001,
            "Item_Description": "File Management",
            "Vendor_Code": "VENDOR-1676"
        },
        "predict": "Product_Category",
        "limit": 3
      }
    `,
  response: stripIndent`
      {
        "$p": 0.9827542339345635,
        "field": "Product_Category",
        "feature": "CLASS-1963"
      },
      {
        "$p": 0.010926112220849838,
        "field": "Product_Category",
        "feature": "CLASS-1274"
      },
      {
        "$p": 0.0056843907309448135,
        "field": "Product_Category",
        "feature": "CLASS-1828"
      }
    `,
  responseExplanation: 'With 98% probability, the missing product category value is CLASS-1963.'
},
{
  id: 2,
  title: 'Recommend optimal value',
  description: 'This query recommends the value for “Product_Category” field with which the value of “Inv_Amt” (invoice amount) is as close to 100 as possible, given the known values.',
  endpoint: 'api/v1/_recommend',
  query: stripIndent`
      {
        "from": "invoice_data",
        "where": {
            "GL_Code": "GL-6100410",
            "Inv_Id": 15001,
            "Item_Description": "File Management",
            "Vendor_Code": "VENDOR-1676"
        },
        "recommend": "Product_Category",
        "goal": {"Inv_Amt": {"$numeric": 100.0}},
        "limit": 3
      }
    `,
  response: stripIndent`
      {
        "$p": 0.8714213369393511,
        "field": "",
        "feature": "CLASS-1274"
      }
    `,
  responseExplanation: 'CLASS-1274 product category is 87% likely to produce an invoice closest to amount of 100.'
},
{
  id: 3,
  title: 'Evaluate accuracy',
  description: 'This query evaluates the accuracy of Aito in predicting the missing product category. It uses every 10th row as a test set to compare prediction results against the real values.',
  endpoint: 'api/v1/_evaluate',
  query: stripIndent`
      {
        "test": {
          "$index": { "$mod": [10, 0] }
        },
        "evaluate": {
          "from": "invoice_data",
          "where": {
            "GL_Code": {"$get": "GL_Code"},
            "Inv_Amt": {"$get": "Inv_Amt"},
            "Item_Description": {"$get": "Item_Description"},
            "Vendor_Code": {"$get": "Vendor_Code"}
          },
          "predict": "Product_Category"
        },
        "select": ["trainSamples", "testSamples", "accuracy", "error"]
      }
    `,
  response: stripIndent`
      {
        "trainSamples": 5009.0,
        "testSamples": 557,
        "accuracy": 1.0,
        "error": 0.0
      }
    `,
  responseExplanation: 'The predictions on 557 samples were 100% accurate'
}]
